export default "__VITE_ASSET__BZsN32wn__"